import {useEffect, useState} from "react";
// -
import {QT2GValuesModel, QT2GHasModel} from "./models/QT2GModels";
import RowTRComponent from "../../../components/RowTRComponent";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import {MiniQ2ServerValuesModel} from "../../../servers/modes/forms/models/MiniQ2Models";

const QT2GForm = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...QT2GValuesModel});
    const [has, setHas] = useState({...QT2GHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...QT2GValuesModel});
            setHas({...QT2GHasModel});
        }
    }, [item]);

    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <RowTRComponent
                        fieldName="ip"
                        _TC={_TC}
                        valueIn={values.ip}
                        hasIn={has.has_ip}
                        deactivated={QT2GValuesModel.ip}
                        styleCenterMiddle={styleCenterMiddle}

                    />
                    <RowTRComponent
                        fieldName={"port"}
                        _TC={_TC}
                        valueIn={values.port}
                        hasIn={has.has_port}
                        deactivated={QT2GValuesModel.port}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"user"}
                        _TC={_TC}
                        valueIn={values.user}
                        hasIn={has.has_user}
                        deactivated={QT2GValuesModel.user}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"pass"}
                        _TC={_TC}
                        valueIn={values.pass}
                        hasIn={has.has_pass}
                        deactivated={QT2GValuesModel.pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_data"}
                        _TC={_TC}
                        valueIn={values.topic_data}
                        hasIn={has.has_topic_data}
                        deactivated={QT2GValuesModel.topic_data}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_alerts"}
                        _TC={_TC}
                        valueIn={values.topic_alerts}
                        hasIn={has.has_topic_alerts}
                        deactivated={QT2GValuesModel.topic_alerts}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_control"}
                        _TC={_TC}
                        valueIn={values.topic_control}
                        hasIn={has.has_topic_control}
                        deactivated={QT2GValuesModel.topic_control}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>

            </div>
        </div>
    )
}
export default QT2GForm